import { observer } from "mobx-react-lite";
import { useContext, useState } from "react";
import { StoreContext } from "../stores/rootStore";
import { Group, Select, Stack, Switch, Title } from "@mantine/core";
import Chart from "react-google-charts";

const SingleNodeResponseTimes: React.FC = observer(() => {
  const rs = useContext(StoreContext);
  const is = rs.influxStore;
  const [logScale, setLogScale] = useState<boolean>(false);

  const graphData = is.singleNodeResponseTimesReq.getData();
  let graph = null;
  if (graphData !== null) {
    const options = {
      title: "Response Time Distribution",
      curveType: "function",
      lineWidth: 4,
      intervals: { style: "line" },
      legend: {
        position: "right",
      },
      vAxis: {
        title: "Response Time (ms)",
        format: "decimal",
        logScale: logScale,
      },
    };
    const dataHeader = [
      { type: "datetime", label: "x" },
      { id: "i0", type: "number", label: "p10" },
      { id: "i1", type: "number", label: "p25" },
      { id: "i2", type: "number", label: "p50" },
      { id: "i3", type: "number", label: "p75" },
      { id: "i4", type: "number", label: "p90" },
      { id: "i5", type: "number", label: "p95" },
      { id: "i6", type: "number", label: "p99" },
    ];
    const dataBody = graphData.data.map((row) => [
      new Date(row.time),
      row.p10 / 1_000_000,
      row.p25 / 1_000_000,
      row.p50 / 1_000_000,
      row.p75 / 1_000_000,
      row.p90 / 1_000_000,
      row.p95 / 1_000_000,
      row.p99 / 1_000_000,
    ]);
    const data = [dataHeader, ...dataBody];
    graph = (
      <Chart height={400} data={data} options={options} chartType="LineChart" />
    );
  }

  return (
    <Stack>
      <Group>
        <Title>Per Node API Response Times</Title>
        <Select
          label="Select a node"
          placeholder="Select a node"
          data={is.hosts.map((host) => ({
            value: host.name,
            label: host.name,
          }))}
          value={is.selectedHost}
          onChange={(value: string | null) => {
            is.selectedHost = value ?? undefined;
          }}
        />
        <Switch
          label="Use log scale"
          checked={logScale}
          onChange={(event) => setLogScale(event.currentTarget.checked)}
        />
      </Group>
      {graph}
    </Stack>
  );
});

export default SingleNodeResponseTimes;
